const products_on_page = document.getElementById('product-grid');
let next_url = products_on_page.dataset.nextUrl;
const load_more_btn = document.getElementsByClassName('load-more_btn')[0];

async function getNextPage() {
  try {
    console.log(next_url);
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  await setTimeout(()=>{}, 1000);
  console.log("this is testing");
  load_more_btn.style.display = 'none';
  $('.load-more').addClass('active-loading');
  let nextPage = await getNextPage();
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
  const productgrid = nextPageDoc.getElementById('product-grid');
  const new_products = productgrid.querySelectorAll('li.grid__item');
  const new_url = productgrid.dataset.nextUrl;
  if (new_url) {
     load_more_btn.style.display = 'flex';
     $('.load-more').removeClass('active-loading');
  } else {
      $('.load-more').removeClass('active-loading');
  }
  next_url = new_url;
  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }
  if(new_products.length > 0) {
      let pageHit = load_more_btn.getAttribute('data-page-hit');
      pageHit = parseInt(pageHit)+1;
      load_more_btn.setAttribute('data-page-hit',pageHit);
  }
  updateCollectionViewed();
}

var pathName = document.location.pathname;
async function loadNoOfPagesLoaded(round) {
  console.log("came here 43");
  console.log(round);

    console.log(round);
  document.body.classList.add("loading-state");
  let pageRound = parseInt(round) - 1;
  document.querySelector(".loading .total").innerHTML = pageRound;
  let pageLoaded = 1;
  let results = null;
  while (pageRound > 0) {
    document.querySelector(".loading .loaded").innerHTML = pageLoaded;
    results = await loadMoreProducts();
    console.log("this"+pageLoaded);
    pageLoaded++;
    pageRound--;
  }
  console.log(localStorage["scrollPosition_" + pathName]);
  console.log("came 86");
  if (localStorage["Temp_scrollPosition_" + pathName]) {
     $(document).scrollTop(localStorage.getItem("Temp_scrollPosition_" + pathName));
     localStorage.removeItem("Temp_scrollPosition_" + pathName);
  }
  else {
    if (localStorage["scrollPosition_" + pathName]) {
        $(document).scrollTop(localStorage.getItem("scrollPosition_" + pathName));
    }
  }
  document.body.classList.remove("loading-state");
   
}

/*
const perfEntries = performance.getEntriesByType('navigation');
if (perfEntries.length && perfEntries[0].type === 'back_forward') {
  if (localStorage["pagesCount_" + pathName]) {
      loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
  }
}
*/
if(localStorage.getItem("detectSafariLoad_" + pathName) == "true" && (localStorage["pagesCount_" + pathName])) {
   console.log(localStorage.getItem("scrollPosition_" + pathName));
  console.log("came 86");
   localStorage.setItem("Temp_scrollPosition_" + pathName, localStorage.getItem("scrollPosition_" + pathName));
}
// For Safri browser
document.addEventListener('DOMContentLoaded', function() {
   // your code here
  if(localStorage.getItem("detectSafariLoad_" + pathName) == "true" && (localStorage["pagesCount_" + pathName])) {
    localStorage.removeItem("detectSafariLoad_" + pathName);
    console.log(localStorage["pagesCount_" + pathName]);
    loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
  }
}, false);

if(performance.navigation.type == 2) {
    console.log(localStorage["pagesCount_" + pathName]);
    if (localStorage["pagesCount_" + pathName]) {
        loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
    }
}

window.onpageshow = function(event) {
    if (event.persisted) {
      var iOS = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
      localStorage.setItem("detectSafariLoad_" + pathName,"true");
      if(!iOS) {
        localStorage.setItem("detectSafariLoad_" + pathName,"true");
      } else {
        if (localStorage["pagesCount_" + pathName]) {
             console.log("came inside");
             //loadNoOfPagesLoaded(localStorage["pagesCount_" + pathName]);
        }

         
      }
    }

};
